import { HttpParams } from '@angular/common/http';
import { CarbonTrackFilters } from '@pages/sustainability/ui/carbon-track/models/carbon-track-filters.model';
import { CarbonTrackPdfRequest } from '@pages/sustainability/ui/carbon-track/models/carbon-track-pdf-request.model';

export class CarbonTrackFiltersMapper {
  public static buildParams(filters: CarbonTrackFilters): HttpParams {
    return new HttpParams({
      fromObject: {
        ...(filters.startDate && { FechaDesde: filters.startDate?.toISOString() }),
        ...(filters.endDate && { FechaHasta: filters.endDate?.toISOString() }),
        ...(filters.cups && { ListaCups: filters.cups.map((i) => i.cups) }),
        ...(filters.employers && { NumEmpleados: filters.employers }),
      },
    });
  }

  public static filtersToRequestModel(filters: CarbonTrackFilters): CarbonTrackPdfRequest {
    return {
      nombreSociedad: filters.society!.nombre,
      instalaciones: filters.cups!.map((i) => {
        return { cups: i.cups, nombreInstalacion: i.nombre };
      }),
      fechaDesde: filters?.startDate?.toISOString() ?? '',
      fechaHasta: filters?.endDate?.toISOString() ?? '',
      numEmpleados: filters?.employers ?? 0,
    };
  }
}
